
import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";

import _ from "lodash";

export const GET_EMAILS = "[EMAILS] GET_EMAILS";
export const GET_EMAILS_SUCCESS = "[EMAILS] GET_EMAILS_SUCCESS";
export const GET_EMAILS_FAILED = "[EMAILS] GET_EMAILS_FAILED";

export const SET_VALUE = "[EMAILS] SET_VALUE";
export const CLEAR_VALUES = "[EMAILS] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}


export function getEmails(
	skip?: number,
	take: number = 10,
	filter?: any[],
	sort?: string,
	desc?: boolean,
	toExport?: boolean,
	callback?: Callback<[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_EMAILS });

		try {
			const { login } = getState();

			const response = await api.sendGet(
				`/Email/activity?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_EMAILS_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / (take || 10)),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_EMAILS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_EMAILS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
